export * from "./ui-router-rx";
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ui-router-rx/lib-esm/index.js
// module id = 895
// module chunks = 4